export const actionTypes = {
    SET_BOT_ACTIVITY_DATA: 'SET_BOT_ACTIVITY_DATA',
    SET_BOT_ACTIVITY_CANCEL_TOKEN: 'SET_BOT_ACTIVITY_CANCEL_TOKEN',
    IS_BOT_ACTIVITY_FETCHING: 'IS_BOT_ACTIVITY_FETCHING'
}